<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitCreatePackage">

      <div class="form-group">
        <label for="partnerData_contractDate">Дата платежного поручения</label>
        <input
            id="partnerData_contractDate"
            v-model="packageData.date"
            type="date"
            class="form-control form-control-sm"
        />
        <div v-if="submitted && $v.packageData.date" class="invalid-feedback">
          <span v-if="!$v.packageData.date.minLength">
            {{$t('validatePhrases.minLength')}}: 10
          </span>
          <span v-if="!$v.packageData.date.maxLength">
            {{$t('validatePhrases.maxLength')}}: 10
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="with_nds">Начальный номер платежных поручений</label>
        <input
            id="with_nds"
            v-model="packageData.start_order_number"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.packageData.start_order_number.$error }"
        />
      </div>

      <div class="form-group">
        <label for="partnerData_contractDate">Период</label>
        <input
            id="partnerData_contractDate"
            v-model="packageData.period"
            type="month"
            class="form-control form-control-sm"
        />
<!--        <div v-if="submitted && $v.packageData.start_period" class="invalid-feedback">-->
<!--          <span v-if="!$v.packageData.start_period.minLength">-->
<!--            {{$t('validatePhrases.minLength')}}: 10-->
<!--          </span>-->
<!--          <span v-if="!$v.packageData.start_period.maxLength">-->
<!--            {{$t('validatePhrases.maxLength')}}: 10-->
<!--          </span>-->
<!--        </div>-->
      </div>

<!--      <div class="form-group">-->
<!--        <label for="partnerData_contractDate">Дата окончания периода</label>-->
<!--        <input-->
<!--            id="partnerData_contractDate"-->
<!--            v-model="packageData.end_period"-->
<!--            type="date"-->
<!--            class="form-control form-control-sm"-->
<!--        />-->
<!--        <div v-if="submitted && $v.packageData.end_period.$error" class="invalid-feedback">-->
<!--          <span v-if="!$v.packageData.contract_date.minLength">-->
<!--            {{$t('validatePhrases.minLength')}}: 10-->
<!--          </span>-->
<!--          <span v-if="!$v.packageData.end_period.maxLength">-->
<!--            {{$t('validatePhrases.maxLength')}}: 10-->
<!--          </span>-->
<!--        </div>-->
<!--      </div>-->

    </form>
  </div>

</template>

<script>

import {integer, email, maxLength, maxValue, minLength, minValue, required} from "vuelidate/lib/validators";

import axios from "axios";
import {padStart} from "@fullcalendar/core";

export default {
  // mixins: [validationMixin],
  name: "CreateMassPartnerProfitOrderPackage",
  data() {
    return {
      packageData: {
        start_order_number: null,
        date: null,
        period: null,
        // start_period: null,
        // end_period: null
      },
      submitted: false,
      defaultPayer: null,
    }
  },
  mounted() {
    this.getDefaultPayer();
  },
  props: {
  },
  watch: {
  },
  computed: {

  },
  validations: {
    packageData: {
      start_period: {minLength: minLength(1), maxLength: maxLength(255)},
      end_period: {minLength: minLength(1), maxLength: maxLength(255)},
    },
  },
  methods: {
    setNullFormDate() {
      this.packageData = {
        payment_payer_id: null,
        start_order_number: null,
        order_date: null,
        period: null,
        // start_period: null,
        // end_period: null
      };
    },
    submitCreatePackage() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.packageData.$touch();
      if (!this.$v.packageData.$invalid) {
        this.$emit('submitCreatePackage', this.packageData);
      }
    },
    getDefaultPayer() {
      axios
          .get(`/v1/payment-payers/get-default`)
          .then(resp => {
            this.defaultPayer = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    generatePackage() {
      let period = new Date(this.packageData.period);

      let start_period = new Date(period.getFullYear(), period.getMonth(), 1);

      start_period = start_period.getFullYear()
          + '-' + String(start_period.getMonth() + 1).padStart(2, "0")
          + '-' + String(start_period.getDate()).padStart(2, "0");

      let end_period = new Date(period.getFullYear(), period.getMonth() + 1, 0);

      end_period = end_period.getFullYear()
          + '-' + String(end_period.getMonth() + 1).padStart(2, "0")
          + '-' + String(end_period.getDate()).padStart(2, "0");

      let formData = new FormData();
      formData.append('payment_payer_id', this.defaultPayer.id);
      formData.append('start_order_number', this.packageData.start_order_number);
      formData.append('date', this.packageData.date);
      formData.append('start_period', start_period);
      formData.append('end_period', end_period);
      axios
          .post(`/v1/mass-partner-profit-order-packages/add`, formData)
          .then(resp => {
            this.$emit('package-created', resp.data);
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
  },
  created() {

  }
};
</script>

<style scoped lang="css">

</style>
